import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import GrommetApp from "./components/grommet-app";

const AppRouter = props => (
  <HashRouter basename="/">
    <Switch>
      <Route exact path="/">
        <GrommetApp page="home" />
      </Route>
      <Route exact path="/resume">
        <GrommetApp page="resume" />
      </Route>
      <Route exact path="/projects">
        <GrommetApp page="projects" />
      </Route>
      <Route render={() => <Redirect push to="/" />} />
    </Switch>
  </HashRouter>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/app-router.js